import * as React from "react";
import {Icon} from "../../../hiberUiKit/src/atoms/Icon/Icon";
import InfoModule from "../../../hiberUiKit/src/molecules/InfoModule/InfoModule";
import {default as DropDownList, DropDownItem} from "../../../hiberUiKit/src/molecules/DropDownList/DropDownList";
import DropDownWrapper from "../../../hiberUiKit/src/molecules/DropDownWrapper/DropDownWrapper";
import StringModal from "./StringModal";
import {Option} from "ts-option";
import TextUtils from "../../../utils/TextUtils";

interface ComponentProps {
	/**
	 * Update custom field value action.
	 * @param {string} updatedValue
	 */
	updateCustomFieldValue: (updatedValue: string) => void;
	/**
	 * Remove custom field value action.
	 */
	removeCustomFieldValue: () => void;
	/**
	 * Custom field label
	 */
	label: string;
	/**
	 * Custom field value
	 */
	value: Option<string>;
}

interface IState {
	menuDropDownVisible: boolean;
	editBoxVisible: boolean;
}

export default class StringDisplay extends React.PureComponent<ComponentProps, IState> {

	filledValueMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
		{id: "l2", label: "Remove"},
		{id: "l3", label: "Copy"},
	];

	emptyValueMenu: DropDownItem[] = [
		{id: "l1", label: "Change"},
	];

	constructor(props: ComponentProps) {
		super(props);
		this.state = {
			menuDropDownVisible: false,
			editBoxVisible: false
		};
		this.toggleMenu = this.toggleMenu.bind(this);
		this.onMenuItemSelect = this.onMenuItemSelect.bind(this);
		this.onValueChange = this.onValueChange.bind(this);
		this.onValueRemove = this.onValueRemove.bind(this);
	}

	render() {
		const menuItems = this.props.value ? this.filledValueMenu : this.emptyValueMenu;
		return (
			<InfoModule icon={Icon.New} title={this.props.label} actionIcon={Icon.Overflow} onActionIconClick={this.toggleMenu}>
				{this.state.menuDropDownVisible &&
				<DropDownWrapper onOutsideClick={() => this.setState({menuDropDownVisible: false})}>
					<DropDownList items={menuItems}
								  itemToId={(link: DropDownItem) => link.id}
								  itemToLabel={(link: DropDownItem) => link.label}
								  onSelect={this.onMenuItemSelect}/>
				</DropDownWrapper>}
				{this.state.editBoxVisible &&
				<StringModal value={this.props.value}
							 title={this.props.label}
							 onChange={(value) => this.setState({editBoxVisible: false},
								 () => {this.onValueChange(value)})}
							 onClose={() => this.setState({editBoxVisible: false})}/>}
				<span className="t-body one-line-display">
                   {this.props.value.getOrElse(`${this.props.label} not provided`)}
                   </span>
			</InfoModule>
		)
	}

	onMenuItemSelect(item: DropDownItem) {
		this.setState({menuDropDownVisible: false});
		switch (item.id) {
			case "l1":
				this.setState({menuDropDownVisible: false, editBoxVisible: true});
				break;
			case "l2":
				this.setState({menuDropDownVisible: false, editBoxVisible: false},
					() => this.onValueRemove());
				break;
			case "l3":
				TextUtils.copyToClipboard(this.props.value.getOrElse(""));
				break;

		}
	}

	toggleMenu() {
		this.setState({menuDropDownVisible: !this.state.menuDropDownVisible})
	}

	onValueChange(value: string) {
		this.props.updateCustomFieldValue(value);
	};

	onValueRemove() {
		this.props.removeCustomFieldValue();
	}
}